import React, { useEffect, useState } from 'react';
import { Dialog, message } from '@tencent/spaui';
import Icon from '@tencent/od-icon';
import globalStore from '@/stores';
import { getAgreementList, getAgreementListBatch, confirmAgreement } from './api';
import { hasRole } from '@/services';
import dialog from '@/utils/dialog';
import PlainTable from '@/common-components/table/PlainTable';

import './index.scoped.less';

interface AgreementData {
  agreement_id: number;
  agreement_name: string;
  agreement_type: number;
  agreement_url: string;
  version: string;
}

const ERROR_COLUMN = [
  {
    name: 'failed_account_id',
    title: '服务商ID',
    flex: 1,
  },
  {
    name: 'failed_msg',
    title: '失败原因',
    flex: 2,
  },
];

const Agreement = () => {
  const [show, setShow] = useState(false);
  const [list, setList] = useState<AgreementData[]>([]);
  const { bm_id, agency_uid } = globalStore.account || {};

  useEffect(() => {
    // 超管和管理才有权限
    if (!hasRole(100) && !hasRole(101)) {
      return;
    }
    const action = bm_id ? getAgreementListBatch : getAgreementList;
    action(bm_id ? { bm_id } : { account_id: agency_uid }).then((res: any) => {
      let list = res?.data?.agreement || [];
      // 兼容单体服务商
      if (!bm_id) {
        list = [{ agreement_infos: list }];
      }
      const map: Record<number, AgreementData> = {};
      list.map((v: any) => v.agreement_infos).flat()
        .forEach((v: AgreementData) => {
          if (!map[v.agreement_type] || v.version > map[v.agreement_type].version) {
            map[v.agreement_type] = v;
          }
        });
      list = Object.values(map);
      setList(list);
      setShow(!!list.length);
    });
  }, []);

  const handleConfirm = async () => {
    message.info('您已成功确认签署协议，签署操作将在后台进行。由于系统处理的需要，您可能会收到弹窗，感谢您的理解与配合！');
    setShow(false);
    const res: any = await confirmAgreement({
      ...(bm_id ? { bm_id } : { account_id: agency_uid }),
      account_agreements: list.map((v) => ({
        agreement_id: v.agreement_id,
        agreement_name: v.agreement_name,
        agreement_type: v.agreement_type,
        version: v.version,
      })),
    });
    if (res?.code !== 0) {
      dialog.alert(res.msg || '签署协议失败');
    } else {
      const failedList = res?.data?.agreement || [];
      if (failedList.length) {
        dialog.alert(<>
          <div>部分服务商签署协议失败</div>
          <PlainTable
            data={failedList}
            columns={ERROR_COLUMN}
          />
        </>, { size: 'large' });
      }
    }
  };

  const handleCancel = async () => {
    setShow(false);
    await confirmAgreement({
      ...(bm_id ? { bm_id } : { account_id: agency_uid }),
      action_type: 2,
      account_agreements: list.map((v) => ({
        agreement_id: v.agreement_id,
        agreement_name: v.agreement_name,
        agreement_type: v.agreement_type,
        version: v.version,
      })),
    });
  };

  // 超管和管理才有权限
  if (!hasRole(100) && !hasRole(101)) {
    return null;
  }

  return <Dialog
    useNewUI={true}
    show={show}
    submitLabel="同意并接受"
    cancelLabel="关闭并继续操作"
    backdrop
    title=""
    hideHeaderDivider={true}
    hideFooterDivider={true}
    closeButton={false}
    footerRightPosition="center"
    onSubmit={handleConfirm}
    onCancel={handleCancel}
  >
    <div className="container">
      <div className="agreement-icon"><Icon name="exclamation-filled" size="medium" color="#ffac40" /></div>
      <div className="agreement-title">协议更新/新增通知</div>
      <div className="text">欢迎使用腾讯营销服务平台(以下简称“腾讯平台”)！</div>
      <div className="text">为了更好地为您提供腾讯营销相关服务，我们对如下协议做了更新/新增，请您仔细阅读、充分理解协议内容并予以遵守。</div>
      <div className="text">您点击下方“同意并接受”或继续使用腾讯平台服务的，即视为您已接受并同意遵守如下协议内容。</div>
      <div className="list">
        {list.map((item) => {
          const { agreement_id, agreement_name, agreement_url } = item;
          return <div className="item" key={agreement_id}>
            <a href={agreement_url} target="blank">{agreement_name}</a>
          </div>;
        })}
      </div>
    </div>
  </Dialog>;
};

export default Agreement;
